'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = 'M560.6 48.01C569.3 47.64 576 40.89 576 32.26V16.13c0-8.1-7.625-16.49-16.62-16.12c-140.1 5.1-260.9 87.25-323.5 204.2C220 196.4 202.4 192 184 192c-64 0-116.4 50.25-119.8 113.4C25.62 322.4 0 360.5 0 404C0 463.5 48.38 512 108 512h296C463.6 512 512 463.5 512 404c0-38.5-20.38-71.87-50.75-91.12c23.63-30.62 59-51.1 99.63-56.12C569.3 255.8 576 249.3 576 240.8V224.8c0-9.25-7.75-16.1-16.75-16.12c-61 5.25-113.9 39.12-145.5 87.87c-1-.125-2-.375-3-.5c-5.625-17.75-16-33.12-29.38-45.25c41.25-55.1 105.8-93.87 179.4-98.5C569.3 151.8 576 145.1 576 136.5V120.5c0-9.125-7.625-16.75-16.75-16.25c-91 5.25-170.6 52.1-220 123.5C330.5 225.3 321.4 223.8 312 223.8c-12 0-23.75 2.5-35 6.5C331.2 126.5 436.9 53.64 560.6 48.01zM312 272c28.62 0 52.38 21.75 55.25 50.37l2.25 21.62H404c33.13 0 60 26.87 60 59.1s-26.88 59.1-60 59.1h-296c-33.12 0-60-26.87-60-59.1c0-27.1 19.12-51.1 46.38-58.25l20.87-4.875L112.4 316C112.2 314.8 112 313.4 112 312c0-39.75 32.25-71.1 72-71.1c25.25 0 48.25 13.12 61.38 35.12l13.38 22.12l21-14.1C289.4 275.6 300.5 272 312 272z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;